import {SaveButton} from '@/components/refinedev/action_buttons';
import TaskForm from './task-form';
import CreateForm from '@/components/refinedev/pages/create-form';

const TaskCreate = () => {
  return (
    <CreateForm
      transformBeforeSave={TaskForm.transformBeforeSave}
      formProps={{defaultValues: TaskForm.defaultValues}}>
      <div className="mx-auto flex flex-col gap-y-4 ">
        <TaskForm />
        <SaveButton size="lg" className="self-end" />
      </div>
    </CreateForm>
  );
};

export default TaskCreate;
